import { PageService } from '../page-service.js';

export class DocPageService extends PageService {}
